module.exports = __webpack_public_path__ + "img/ic_bank_ktb_disables.91915bcb.png";